import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from '../theme';
import { apiUrl } from '../api';
import { useLanguage } from '../App';

export default function EditCar() {
  const { id } = useParams();
  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { tokens } = useTheme();
  const { language } = useLanguage();

  const t = {
    en: {
      editCar: 'Edit Car',
      loading: 'Loading...',
      carNotFound: 'Car not found',
      title: 'Title',
      brand: 'Brand',
      price: 'Price',
      year: 'Year',
      model: 'Model',
      pollutionStandard: 'Pollution standard',
      save: 'Save'
    },
    ro: {
      editCar: 'Editează mașina',
      loading: 'Se încarcă...',
      carNotFound: 'Mașina nu a fost găsită',
      title: 'Titlu',
      brand: 'Marcă',
      price: 'Preț',
      year: 'An',
      model: 'Model',
      pollutionStandard: 'Normă de poluare',
      save: 'Salvează'
    }
  };
  const tr = t[language] || t.ro;

  useEffect(() => {
    fetch(apiUrl(`/api/cars/${id}`))
      .then(res => res.json())
      .then(data => {
        setCar(data);
        setLoading(false);
      });
  }, [id]);

  function handleChange(e) {
    setCar({ ...car, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    fetch(apiUrl(`/api/cars/${id}`), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(car)
    })
      .then(res => res.json())
      .then(() => navigate(`/car/${id}`));
  }

  if (loading) return <div style={{ color: tokens.text, textAlign: 'center', marginTop: 64 }}>{tr.loading}</div>;
  if (!car) return <div style={{ color: tokens.text, textAlign: 'center', marginTop: 64 }}>{tr.carNotFound}</div>;

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: 32, background: tokens.surface, borderRadius: 18, color: tokens.text }}>
      <h2 style={{ fontSize: 28, fontWeight: 700, marginBottom: 24 }}>{tr.editCar}</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <input name="title" value={car.title || ''} onChange={handleChange} placeholder={tr.title} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }} />
        <input name="marca" value={car.marca || car.brand || ''} onChange={handleChange} placeholder={tr.brand} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }} />
        <input name="price" value={car.price || ''} onChange={handleChange} placeholder={tr.price} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }} />
        <input name="year" value={car.year || ''} onChange={handleChange} placeholder={tr.year} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }} />
        <input name="model" value={car.model || ''} onChange={handleChange} placeholder={tr.model} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }} />
        {/* Norma de poluare */}
        <select name="normaPoluare" value={car.normaPoluare || ''} onChange={handleChange} style={{ padding: 8, borderRadius: 8, border: `1px solid ${tokens.mutedBorder}`, background: tokens.panel, color: tokens.text, fontSize: 18 }}>
          <option value="">{tr.pollutionStandard}</option>
          <option value="Euro 3">Euro 3</option>
          <option value="Euro 4">Euro 4</option>
          <option value="Euro 5">Euro 5</option>
          <option value="Euro 6">Euro 6</option>
        </select>
        {/* Add more fields as needed */}
        <button type="submit" style={{ background: tokens.accent, color: tokens.inverse, border: 'none', borderRadius: 8, padding: '10px 0', fontWeight: 700, fontSize: 18, cursor: 'pointer', marginTop: 12 }}>{tr.save}</button>
      </form>
    </div>
  );
}
